import moment from 'moment'

export function getDateFromPeriod(period, startDate, endDate) {
  const ms = moment(startDate)
  switch(period) {
    case 'day': // day
      return [startDate, startDate]
    case 'week': // week
      return [ms.startOf('week').toDate(), ms.endOf('week').toDate()]
    case 'month': // month
      return [ms.startOf('month').toDate(), ms.endOf('month').toDate()]
    case 'year': // year
      return [ms.startOf('year').toDate(), ms.endOf('year').toDate()]
    default: // range
      return [startDate, endDate]
  }
}